import { takeLatest, put, call } from "redux-saga/effects";
import {
  addAffiliateAction,
  getActiveAffiliateAction,
  getAffiliateAction,
  getAffiliateByName,
  totalNumberOfAffiliateAction,
  updateAffiliateAction,
} from "../api/affiliate-action";
import {
  getAffiliate,
  getAllActiveAffiliates,
  getTotalnumberOfAffiliates,
  setAffiliateError,
  setIsAffiliateCreating,
  setIsAffiliateLoading,
  setTotalPage,
  // setAffiliateData,
} from "../redux/app/affiliate/affiliate-slice";
import { toast } from "react-toastify";

export function* createAffiliateSaga(actions) {
  try {
    yield put(
      setIsAffiliateCreating({
        isAffiliaeCreating: true,
      })
    );
    const response = yield call(addAffiliateAction, actions.payload);

    if (response.status === 200) {
      yield put(
        setIsAffiliateCreating({
          isAffiliaeCreating: false,
        })
      );
      yield put({
        type: "GET_ALL_AFFILIATES",
        payload: {
          token: actions.payload.token,
          page: 1,
          limit: 20,
          search: "",
        },
      });
      yield put({
        type: "TOTAL_NUMBER_OF_AFFILIATES",
        payload: actions.payload.token,
      });
      toast.success("Affiliate Created Successfully");
    }
  } catch (error) {
    toast.error(error.response.data.message);
  }
}

export function* getAffiliateSaga(actions) {
  try {
    yield put(
      setIsAffiliateLoading({
        affiliateIsLoading: true,
      })
    );
    const response = yield call(getAffiliateAction, actions.payload);

    if (response?.status === 200) {
      yield put(
        setIsAffiliateLoading({
          affiliateIsLoading: false,
        })
      );
      yield put(
        getAffiliate({
          affiliates: response.data.affiliateDetails,
        })
      );
      yield put(setAffiliateError({ affiliateError: "" }));
    }
  } catch (error) {
    if (error.response.data.error) {
      yield put(setAffiliateError({ affiliateError: "No Affiliates Found" }));
    }
    if (error.response.data.message) {
      yield put(
        setAffiliateError({ affiliateError: error.response.data.message })
      );
    }
  }
}

export function* getActiveAffiliateSaga(actions) {
  try {
    const response = yield call(getActiveAffiliateAction, actions.payload);
    yield put(
      getAllActiveAffiliates({
        activeAffiliates: response,
      })
    );
  } catch (error) {}
}

export function* totalNumberOFAffiliate(actions) {
  try {
    const response = yield call(totalNumberOfAffiliateAction, actions.payload);
    yield put(
      getTotalnumberOfAffiliates({
        totalNumberOfAffiliates: response.data,
      })
    );
    yield put(
      setTotalPage({
        totalPages: Math.ceil(response.data / 20),
      })
    );
  } catch (error) {}
}

export function* affiliateUpdateSaga(actions) {
  try {
    const response = yield call(updateAffiliateAction, actions.payload);
    if (response.status === 200) {
      yield put({
        type: "GET_ALL_AFFILIATES",
        payload: {
          token: actions.payload.token,
          page: 1,
          limit: 20,
          search: "",
        },
      });
      toast.success("Affiliate Updated Successfully");
    }
  } catch (error) {}
}

export function* searchAffiliateNameSaga(actions) {
  try {
    const response = yield call(getAffiliateByName, actions.payload);

    yield put(
      getAffiliate({
        affiliates: response?.data,
      })
    );
  } catch (error) {}
}

export function* watchAffiliateAsync() {
  yield takeLatest("CREATE_AFFILIATE", createAffiliateSaga);
  yield takeLatest("GET_ALL_AFFILIATES", getAffiliateSaga);
  yield takeLatest("TOTAL_NUMBER_OF_AFFILIATES", totalNumberOFAffiliate);
  yield takeLatest("UPDATE_AFFILIATE", affiliateUpdateSaga);
  yield takeLatest("SEARCH_AFFILIATE_NAME", searchAffiliateNameSaga);
  yield takeLatest("GET_ALL_ACTIVE_AFFILIATES", getActiveAffiliateSaga);
}
